import type { Color } from '../_styles/colors'

export const visibleItemsCap = 5

export const foldedItemsCap = 4

export const restCountThreshold = 99

export const colorsOrder: Color[] = ['blue40', 'purple40', 'orange40', 'gray40']
